import React from "react";
import { WPPost } from "../../../constants/types";
import {
    ChallengingSituationsACF,
    ConditionPostTypeACF,
    PopulationPostTypeACF,
} from "../../../constants/types/acf";
import { ContentPersonaliser } from "../../molecules/ContentPersonaliser";
import { OnThisPage } from "../../molecules/OnThisPage";
import { ContentBuilder } from "../ContentBuilder";
import { Outer, Inner, Sidebar, Main, CustomContainer } from "./styled";

interface Props {
    page: WPPost<PopulationPostTypeACF | ConditionPostTypeACF | ChallengingSituationsACF>;
    showLocalServicesAnchor?: boolean;
}

export const PostTypePageContent: React.FC<Props> = props => {
    const [showingAltContent, setShowingAltContent] = React.useState(false);
    const hasAlternateCopy = props.page.acf.enable_alternate_content;
    const content = showingAltContent ? props.page.acf.alternate_content : props.page.acf.content;

    return (
        <Outer>
            <CustomContainer>
                {hasAlternateCopy && (
                    <ContentPersonaliser
                        personalised={showingAltContent}
                        onChange={setShowingAltContent}
                    />
                )}
                <Inner>
                    <Sidebar>
                        <OnThisPage
                            content={content}
                            showLocalServicesAnchor={props.showLocalServicesAnchor}
                        />
                    </Sidebar>
                    <Main>
                        <ContentBuilder content={content} />
                    </Main>
                </Inner>
            </CustomContainer>
        </Outer>
    );
};
